<template>
<div class="body apply">
    <div class="wrap">
        <div class="con">
            <div class="title">
                <h2>프로그램 선택하기</h2>
                <p>신청할 프로그램을 선택해 주시기 바랍니다.</p>
            </div>
            <div class="apply-main-program">
                <ul>
                    <li v-for="(item, index) of program_types" :key="index" class="pointer">
                        <p v-if="item.program_type === 'L'" class="program-title">
                            1:1 Language Lab 과정
                        </p>
                        <p v-else-if="item.program_type === 'U'" class="program-title">
                            Untact 과정
                        </p>
                        <p v-else-if="item.program_type === 'G'" class="program-title">
                            Group 과정
                        </p>
                        <p v-else-if="item.program_type === 'S'" class="program-title">
                            특강
                        </p>
                        <p v-else-if="item.program_type === 'E'" class="program-title">
                            기타
                        </p>
                        <span>신청하기</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    GetUrlParams
} from '@/utils/common.js'
export default {
    data: () => ({
        pageIdx: '',
        program_types: []
    }),

    mounted() {
        var oParams = GetUrlParams()
        this.pageIdx = oParams.pageIdx

        this.fetchProcessData()
    },

    methods: {
        // 선택한 수강페이지 등록 진행 => 약관동의 페이지 이동
        apply() {
            this.$router.push('/user/reg/terms')
        },

        fetchProcessData() {
            var params = {
                pageIdx: this.pageIdx
            }

            this.axios.get(this.axios.root + this.axios.port + `/user/select-program/${this.pageIdx}`, {
                params: params
            }).then(res => {
                console.log('res', res)
                if (res.data.err === 0) {
                    for (var item of res.data.programList) {
                        this.program_types.push({
                            program_type: item.program_type,
                            programIdx: item.idx
                        })
                    }
                } else {
                    alert(res.data.result)
                }
            }).catch(err => {
                console.log(err)
                alert(err)
            })

        },
    }
}
</script>
